// extracted by mini-css-extract-plugin
export default {"selectDropdown":"Applications_selectDropdown__OPR-9"};